export default __webpack_public_path__ + "static/media/google-forms.931dd80b.svg";